import { render, staticRenderFns } from "./DisasterManagementOfficer.vue?vue&type=template&id=8ce0a0e0&scoped=true"
import script from "./DisasterManagementOfficer.vue?vue&type=script&lang=js"
export * from "./DisasterManagementOfficer.vue?vue&type=script&lang=js"
import style0 from "./DisasterManagementOfficer.vue?vue&type=style&index=0&id=8ce0a0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce0a0e0",
  null
  
)

export default component.exports